import { forwardRef, useEffect, useState } from "react";
import {
    PersonDeleteRegular
} from "@fluentui/react-icons";
import { Button, ForwardRefComponent, MenuItem, makeStyles } from "@fluentui/react-components";
import { IRemoveGuestUsersActionButtonProps } from "./remove-guest-users-action-button.props";
import { IRemoveGuestUsersSelection } from "@interfaces/actions/guest-user-actions.interfaces";
import { IActionDefinition } from "@interfaces/actions/actions-common.interfaces";
import { getActionFormComponent, getActionResultComponent } from "lib/actions";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { PPAPermissions } from "lib/permissions";
import { usePPA } from "context/ppa-context";

const layoutStyles = makeStyles({
    mainWrapper: {
    },
    hidden: {
        display: 'none'
    }
});

export const RemoveGuestUsersActionButton: ForwardRefComponent<IRemoveGuestUsersActionButtonProps> = forwardRef((props, ref) => {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    const { hasPermission } = usePPA();

    const [model, setModel] = useState<IRemoveGuestUsersSelection | undefined>();

    const [className, setClassName] = useState<string>(styles.hidden);

    const onClick = () => {
        console.log(`RemoveGuestUsersActionButton -> onClick ->`);

        const actionDefinition: IActionDefinition<IRemoveGuestUsersSelection> = {
            actionType: 2,
            model: model,
            form: getActionFormComponent(2),
            result: getActionResultComponent(2)
        };

        if (props.onClick) {
            props.onClick(actionDefinition);
        }
    }

    useEffect(() => {
        console.log(`RemoveGuestUsersActionButton -> useEffect -> selectedItems ->`, props.selectedItems);

        if (props.selectedItems && props.selectedItems.length === 1) {
            const item = props.selectedItems[0];
            setModel({
                site: {
                    url: item.memberOfUrl,
                    name: item.memberOfName,
                    workspaceType: item.memberOfType
                },
                user: {
                    upn: item.upn,
                    name: item.displayName
                }
            });
        }
        else {
            // Clear the model
            setModel(undefined);
        }

        if (props.selectedItems && props.selectedItems.length > 0) {
            setClassName('');
        }
        else {
            setClassName(styles.hidden);
        }
    }, [props.selectedItems]);

    if (!hasPermission(PPAPermissions.RequestRemoveGuestUsersAction))
        return (<></>);

    if (props.isOverflowingMenu)
        if (props.selectedItems && props.selectedItems.length > 0)
            return (
                <MenuItem
                    icon={<PersonDeleteRegular />}
                    disabled={props.selectedItems && props.selectedItems.length > 1}
                    onClick={onClick}>{t('remove')}</MenuItem>
            );
        else
            return <></>;

    return (
        <Button
            ref={ref}
            className={className}
            icon={<PersonDeleteRegular />}
            disabled={props.selectedItems && props.selectedItems.length > 1}
            appearance="subtle"
            onClick={onClick}>{t('remove')}</Button>
    );
});